var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,12.075C24,5.405 18.628,0 12.003,0C5.378,0 0,5.405 0,12.075C0,18.1 4.388,23.095 10.124,24L10.124,15.565L7.077,15.565L7.077,12.075L10.124,12.075L10.124,9.415C10.124,6.39 11.913,4.72 14.657,4.72C15.969,4.72 17.345,4.955 17.345,4.955L17.345,7.925L15.834,7.925C14.343,7.925 13.876,8.855 13.876,9.81L13.876,12.075L17.206,12.075L16.674,15.565L13.876,15.565L13.876,24C19.612,23.095 24,18.1 24,12.075Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.576f56d1c6feb4303e065a445553471a.svg";
export { ForwardRef as ReactComponent };